import React from 'react';
import { Box, Heading, Text, Flex, HStack } from '@chakra-ui/react';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link} from 'react-router-dom';

const Restaurant = () => {
  const restaurantName = "Sample Restaurant";
  const restaurantDescription = "A cozy place for delicious meals.";
  const restaurantAddress = "123 Main St, City, Country";

  return (
    <Box bg="gray.50" p={2}>
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Flex justifyContent="space-between">
          <Box>
            <Heading color="blue.200">{restaurantName}</Heading>
            <Text color="blue.200" mt={2}>{restaurantDescription}</Text>
            <Text color="blue.200" mt={1}>{restaurantAddress}</Text>
          </Box>
          <Flex flexDirection="column" alignItems="flex-end">
            <Link to="/restaurant-wallet" color="blue.200">
                <HStack spacing={2}>
                <FaWallet />
                <Text>Wallet Balance</Text>
                </HStack>
            </Link>
            <Text mt={2} color="blackAlpha.600">
                $500.00
            </Text>
         </Flex>
        </Flex>
      </Box>
      
      <Flex>
        <Link to="/restaurant-orders" flex="1">
            <Box bg="white" p={4} flex="1" borderRadius="md" mr={4}>
                <HStack spacing={2}>
                <FaChartLine color="blue.200" />
                <Text color="blue.200" fontWeight="bold">Orders</Text>
                </HStack>
            </Box>
         </Link>

         <Link to="/restaurant-analytics" flex="1">
            <Box bg="white" p={4} flex="1" borderRadius="md">
            <HStack spacing={2}>
                <FaChartLine color="blue.200" />
                <Text color="blue.200" fontWeight="bold">Analytics</Text>
            </HStack>
            {/* Include your graphs or data here */}
            </Box>
        </Link>
      </Flex>

      <Flex mt={4}>
        <Link to="/restaurant-notifications" flex="1">
          <Box bg="white" p={4} borderRadius="md" mr={4}>
            <HStack spacing={2}>
              <FaBell color="blue.200" />
              <Text color="blue.200" fontWeight="bold">Notifications</Text>
            </HStack>
          </Box>
        </Link>

        <Link to="/restaurant-transactions" flex="1">
          <Box bg="white" p={4} borderRadius="md">
            <HStack spacing={2}>
              <FaExchangeAlt color="blue.200" />
              <Text color="blue.200" fontWeight="bold">Transactions</Text>
            </HStack>
          </Box>
        </Link>
      </Flex>

      {/* Bottom Navigation for Mobile */}
      <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>     

    </Box>
  );
};

export default Restaurant;
